import MovimientoUpdate from './MovimientoUpdate'
export {MovimientoUpdate}
export default MovimientoUpdate
